import React, { useEffect, useState } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from 'react-router-dom';
import Header from './components/home/Header';
import Footer from './components/home/Footer';
import ScrollToTop from './components/home/ScrollToTop';
import Home from './components/home/home';
import About from './components/about/AboutUs';
import Contact from './components/contact/Contact';
import Service from './components/service/Services';
import Blog from './components/blog/Blogs';
import BlogDetails from './components/blog/BlogDetails';
import AppointmentPage from './components/appointment/AppointmentPage';
import TermsConditions from './components/termsconditions/TermsConditions';
import PrivacyPolicy from './components/privacypolicy/PrivacyPolicy';
import Success from './components/appointment/Success';
import Cancel from './components/appointment/Cancel';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './App.css';
import spinner from './assets/images/loading.gif';

const ScrollToTopButton: React.FC = () => {
  const [visible, setVisible] = useState(false);

  const toggleVisible = () => {
    const scrolled = document.documentElement.scrollTop;
    setVisible(scrolled > 300);
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  useEffect(() => {
    window.addEventListener('scroll', toggleVisible);
    return () => window.removeEventListener('scroll', toggleVisible);
  }, []);

  return (
    <button
      onClick={scrollToTop}
      style={{
        position: 'fixed',
        right: '20px',
        bottom: '30px',
        height: '50px',
        width: '50px',
        borderRadius: '50%',
        border: 'none',
        backgroundColor: '#082341',
        color: '#fff',
        fontSize: '20px',
        cursor: 'pointer',
        zIndex: 9999,
        opacity: visible ? 1 : 0,
        transition: 'opacity 0.4s, visibility 0.4s',
      }}
      aria-label="Scroll to top"
    >
      <i className="bi bi-chevron-up"></i>
    </button>
  );
};

const AppContent: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    const routeTitleMap: { [key: string]: string } = {
      '/': 'Shahlpo',
      '/about-us': 'Shahlpo | About Us',
      '/contact-us': 'Shahlpo | Contact Us',
      '/services': 'Shahlpo | Our Services',
      '/blog': 'Shahlpo | Blog',
    };

    let title = routeTitleMap[location.pathname];
    if (location.pathname.startsWith('/blog/')) {
      title = 'Shahlpo | Blog';
    }

    document.title = title || 'Shahlpo';
  }, [location.pathname]);

  return (
    <>
      <Header />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about-us" element={<About />} />
        <Route path="/contact-us" element={<Contact />} />
        <Route path="/services" element={<Service />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogDetails />} />
        <Route path="/appointment" element={<AppointmentPage />} />
        <Route path="/terms-conditions" element={<TermsConditions />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/success" element={<Success />} />
        <Route path="/cancel" element={<Cancel />} />
      </Routes>
      <Footer />
      <ScrollToTopButton />
    </>
  );
};

const App: React.FC = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
      window.scrollTo(0, 0); // Ensure scroll is at top after loading
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          height: '100vh',
          width: '100vw',
          backgroundColor: '#fff',
          zIndex: 9999,
        }}
      >
        <img
          src={spinner}
          alt="Loading..."
          style={{ width: '150px', height: '150px' }}
        />
      </div>
    );
  }

  return (
    <Router>
      <AppContent />
    </Router>
  );
};

export default App;
